(function() {
    'use strict';
    angular
        .module('sideApp')
        .factory('ReporteEvaluativoRegularService', ReporteEvaluativoRegularService);

    ReporteEvaluativoRegularService.$inject = ['$resource'];

    function ReporteEvaluativoRegularService ($resource) {
        var resourceUrl =  'apo/reporteEvaluativo/reporteRegular:idA,:idP,:idAnio,:idIndice,:ic,:iic,:tipoEvaluacion,:idDependencia,:nivell,:modeloo';

        return $resource(resourceUrl, {}, {
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': {
            	url:'apo/guardarreporteregular:id',
            	method:'PUT' 
            },
            'save': {
            	url:'apo/guardarreporteregular:id',
            	method: 'POST',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            }
            ,
            'getRevision': {
            	url:'apo/revisionreporteregular:id',
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'ver': {
            	url:'apo/verreporteregular:id',
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
        });
    }
})();